import React, { FC } from 'react';
import { ModalOverlay } from '../../Modal';

interface Props {
  onClose: () => void;
  show: boolean;
  children?: React.ReactNode;
}

export const SocialAuthModalOverlay: FC<Props> = ({ children, ...rest }) => (
  <ModalOverlay {...rest}>{children}</ModalOverlay>
);
